import {useAppSelector} from '@/hooks/useRedux';
import {selectMinimizedTransactions} from '@/store/transactions/selectors';

export const useTransactionsToasts = () => {
  const transactions = useAppSelector(selectMinimizedTransactions);

  return {
    transactions,
  };
};
